import React, { Component } from 'react';
import {
  Text,
  View,
  ScrollView,
  TouchableOpacity,
  FlatList,
  Dimensions,
  Alert,
  Image,
  DeviceEventEmitter,
} from 'react-native';
import { withTranslation } from 'react-i18next';
import IconI from 'react-native-vector-icons/Ionicons';
import IconF from 'react-native-vector-icons/Feather';
import IconM from 'react-native-vector-icons/MaterialCommunityIcons';
import RenderDataHTML from './render-data-html';
import styles from './ReviewTestStyle';
import ReviewSubjectTypes from './ReviewSubjectTypes';
import CountDown from "./Countdowns";
import MathJax from "react-mathjax-preview";
import Modal from 'react-native-modal';
 class ReviewTest extends Component {


    constructor(props) {
        super(props);
    
        this.state = {
          pageActive: 0,
          itemQuestion: props?.data?.questions[0] ?? null,
          data: props?.data ?? null,
          dataQuiz: props?.data ?? null,
          isVisible: false,
          visible: false,
          explainationcontent: '',
          ismathquestion: '',
          isViewContent: false,
          topics:props.topics,
          showExplaination: false
        };
    
        this.exameventListner =null;
      }
    
      async componentDidMount() {
    
        this.exameventListner = DeviceEventEmitter.addListener(
            'examchangesubjectquestions',
            this.changeexamquestions,
          );
    
      }
    
      componentWillUnmount() {
      
       
        if(this.exameventListner){
            this.exameventListner.remove();
        }
      }
    
      selectQuestion(item) {
        const { itemQuestion } = this.state;
    
        if (
          itemQuestion.type === 'single_choice' ||
          itemQuestion.type === 'true_or_false'
        ) {
          itemQuestion.answer = [item];
          this.forceUpdate();
        }
        if (itemQuestion.type === 'multi_choice') {
          if (itemQuestion?.answer) {
            const temp = itemQuestion?.answer.find(x => x.value === item.value);
            if (temp) {
              itemQuestion.answer = itemQuestion.answer.filter(
                x => x.value !== item.value,
              );
              this.forceUpdate();
            } else {
              itemQuestion.answer = [...itemQuestion.answer, item];
              this.forceUpdate();
            }
          } else {
            itemQuestion.answer = [item];
            this.forceUpdate();
          }
        }
      }
    
      onPrevQuiz = () => {
        const { pageActive, dataQuiz } = this.state;
        this.flatListRef.scrollToIndex({
          index: pageActive - 1,
          animated: true,
        });
        this.setState({
          itemQuestion: dataQuiz.questions[pageActive - 1],
          pageActive: pageActive - 1,
          visible:false
        });
      };
    
      onNextQuiz = () => {
        const { pageActive, dataQuiz } = this.state;
        this.flatListRef.scrollToIndex({
          index: pageActive + 1,
          animated: true,
        });
        this.setState({
          itemQuestion: dataQuiz.questions[pageActive + 1],
          pageActive: pageActive + 1,
          visible:false
        });
      };
    
      changeexamquestions =async(item) =>{
        
        let startFrom =parseInt(item.startfrom);
        const { t } = this.props;
        const { pageActive, dataQuiz } = this.state;
        
        this.flatListRef.scrollToIndex({
          index: startFrom ,
          animated: true,
        });
        this.setState({
          itemQuestion: dataQuiz.questions[startFrom],
          pageActive: startFrom,
          
        });
    
      }
    
      renderHeaderItem = ({ item, index }) => {
        const { pageActive } = this.state;
        // if (index > 5 && pageActive < 5)
        //   return <Text style={{ marginLeft: 3, marginTop: 3 }}>...</Text>;
        return (
          <TouchableOpacity
            onPress={() =>
              this.setState({
                pageActive: index,
                itemQuestion: item,
                visible: false
              })
            }
            style={[
              styles.btnPage,
              {
                backgroundColor: pageActive === index ? '#FBC815' : '#fff',
                borderColor: pageActive === index ? '#FBC815' : '#E4E4E4',
              },
            ]}>
            <Text style={styles.txtPage}>{index + 1}</Text>
          </TouchableOpacity>
        );
      };
    
      itemOption = (item, i) => {
        const { data, itemQuestion } = this.state;
        console.log(data.results.answered);
        const userAnswer = data.results.answered[itemQuestion.id].answered;
    
        //['7054'];
        //data.results.answered[itemQuestion.id].answered;
        //alert(JSON.stringify(userAnswer));
        //alert(item.value);
    
        return (
          <TouchableOpacity key={String(i)} style={styles.itemQuestion}>
            {data.results.answered[itemQuestion.id]?.correct &&
              String(userAnswer).includes(item.value) ? (
              <IconI name="checkmark-circle-outline" size={14} color="#36CE61" />
            ) : item?.is_true === 'yes' ? (
              <IconI name="checkmark-circle-outline" size={14} color="#36CE61" />
            ) : String(userAnswer).includes(item.value) ? (
              <IconI name="close-circle-sharp" size={14} color="#FF4444" />
            ) : (
              <IconI name="ellipse-outline" size={14} color="#878787" />
            )}
    
            {/* <Text style={styles.txtItemQuestion}>
              <RenderDataHTML
                html={item?.title}
                style={styles.txtItemQuestion}
              />
            </Text>*/}
    
            {itemQuestion?.ismathquestion == 'No' && <RenderDataHTML
              html={item?.title}
              style={styles.txtItemQuestion}
            />}
    
            {itemQuestion?.ismathquestion == 'Yes' &&
    
              <View style={{ flex: 1 }}>
                {this.rennderMath(item?.title)}
    
              </View>
            }
          </TouchableOpacity>
        );
      };
    
      itemOptionMultiChoice = (item, i) => {
        const { data, itemQuestion } = this.state;
        const userAnswer = data.results.answered[itemQuestion.id].answered;
        return (
          <TouchableOpacity key={String(i)} style={styles.itemQuestion} disabled>
            {data.results.answered[itemQuestion.id]?.correct &&
              userAnswer.includes(item.value) ? (
              <IconI name="checkmark-circle-outline" size={14} color="#36CE61" />
            ) : item?.is_true === 'yes' ? (
              <IconI
                name="checkmark-circle-outline"
                size={14}
                color={userAnswer.includes(item.value) ? '#36CE61' : '#FF4444'}
              />
            ) : (
              <IconI
                name="square-outline"
                size={14}
                color={userAnswer.includes(item.value) ? '#FF4444' : '#878787'}
              />
            )}
            {/* <Text style={styles.txtItemQuestion}><RenderDataHTML
              html={item?.title}
              style={styles.txtItemQuestion}
            />
            </Text>*/}
            {itemQuestion?.ismathquestion == 'No' && <RenderDataHTML
              html={item?.title}
              style={styles.txtItemQuestion}
            />}
    
            {itemQuestion?.ismathquestion == 'Yes' &&
    
              <View style={{ flex: 1 }}>
                {this.rennderMath(item?.title)}
    
              </View>
            }
          </TouchableOpacity>
        );
      };
    
      renderFillInBlanks = item => {
        const lstIdKeys = [];
        const { itemQuestion, data } = this.state;
        const { ids, title_api } = item;
        ids.forEach(id => {
          lstIdKeys.push({ id, key: `{{FIB_${id}}}` });
        });
    
        const userAnswer = data.results.answered[itemQuestion.id].answered;
    
        const words = title_api.split(' ');
        return words.map((i, k) => {
          const itemKey = lstIdKeys.find(x => x.key === i);
          if (itemKey) {
            return (
              <View
                key={String(k)}
                style={{
                  minWidth: 60,
                  paddingVertical: 2,
                  paddingHorizontal: 5,
                  backgroundColor: '#ECECEC',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexDirection: 'row',
                }}>
                {!item.answers[itemKey.id]?.is_correct && (
                  <Text
                    style={{
                      fontWeight: 'bold',
                      color: '#000000',
                    }}>
                    {userAnswer[itemKey.id]}
                  </Text>
                )}
                {!item.answers[itemKey.id]?.is_correct &&
                  item.answers[itemKey.id]?.correct && (
                    <IconF name="arrow-right" color="#666" size={14} />
                  )}
                <Text
                  style={{
                    fontWeight: 'bold',
                    color: '#36CE61',
                  }}>
                  {item.answers[itemKey.id]?.correct
                    ? `${item.answers[itemKey.id]?.correct}`
                    : ''}
                </Text>
              </View>
            );
          }
          return <Text key={String(k)}> {i} </Text>;
        });
      };
    
      renderItemSortChoice = itemParam => {
        const { t } = this.props;
        const { itemQuestion, data } = this.state;
        // tronLog('item1111', itemQuestion, itemParam);
        const userAnswer = data.results.answered[itemQuestion.id].answered;
    
        const dataSort = itemParam.options.sort((a, b) => a.sorting - b.sorting);
        return (
          <FlatList
            keyExtractor={item => `draggable-item-${item.value}`}
            data={userAnswer}
            renderItem={({ item, index }) => (
              <View style={{ marginBottom: 10 }}>
                <TouchableOpacity
                  disabled
                  style={{
                    padding: 8,
                    borderColor: '#F3F3F3',
                    borderWidth: 1,
                    borderRadius: 6,
                    alignItems: 'center',
    
                    // justifyContent: 'center',
                    flexDirection: 'row',
                    // marginHorizontal: 16,
                    marginBottom: 12,
                    backgroundColor: '#fff',
                  }}>
                  <IconI
                    name="menu"
                    size={22}
                    color="#000"
                    style={{ marginRight: 10 }}
                  />
                  <Text style={styles.txtItemQuestion}>
                    {itemParam.options.find(x => x.value === item).title}
                  </Text>
                </TouchableOpacity>
                <View
                  style={{
                    padding: 8,
                    borderColor: '#6CDA45',
                    borderWidth: 1,
                    borderRadius: 6,
                    alignItems: 'center',
                    flexDirection: 'row',
                  }}>
                  <Text style={styles.txtItemQuestion}>
                    {dataSort[index].title}
                  </Text>
                </View>
              </View>
            )}
          />
        );
      };
    
      showdialogbox = async (explaination, ismathquestion) => {
    
        await this.setState({
          visible: true,
          explainationcontent: explaination,
          ismathquestion: ismathquestion,
          showExplaination:true,
        })
      }
    
      closedialog = async () => {
        await this.setState({
          visible: false
        })
      }
    
    
    
      rennderMath = (item) => {
    
        let splititems = '';

        if (item != '') {
          splititems = item.split('<mspace linebreak="newline"/>');
        } else {
          splititems = this.state.hintscontent.split('<mspace linebreak="newline"/>');
        }
    
        let mathcontent = `<math xmlns="http://www.w3.org/1998/Math/MathML"><mi>$</mi><munderover accent='false' accentunder='false'><mo>&#x222f;</mo><mrow><mn>3</mn><mo>&#x22c3;</mo></mrow><mn>2</mn></munderover><mo>&#xA0;</mo><mo>&#xA0;</mo><mi>w</mi><mi>h</mi><mi>a</mi><mi>t</mi><mo>&#xA0;</mo><mi>w</mi><mi>i</mi><mi>l</mi><mi>l</mi><mo>&#xA0;</mo><mi>b</mi><mi>e</mi><mo>&#xA0;</mo><mi>t</mi><mi>h</mi><mi>e</mi><mo>&#xA0;</mo><mi>v</mi><mi>a</mi><mi>l</mi><mi>u</mi><mi>e</mi><mi>&#x394;</mi><mo>&#xA0;</mo><mn>3</mn><mo>&#xA0;</mo><mi>w</mi><mi>i</mi><mi>l</mi><mi>l</mi><mo>&#xA0;</mo></math`;
        let newarray = [];
        let counter = 0;
        splititems.reduce(async (promise, res1) => {
    
    
          let newreq = ''
          let req = {
            id: '',
            newreq: ''
          }
          if (counter == 0) {
            newreq = res1 + '</math>';
            req.id = counter;
            req.newreq = newreq;
          }
          if (counter > 0 && counter != splititems.length - 1) {
            newreq = '<math xmlns="http://www.w3.org/1998/Math/MathML">';
            newreq = newreq + res1 + '</math>';
            req.id = counter;
            req.newreq = newreq;
          }
    
          if (counter > 0 && counter == splititems.length - 1) {
            newreq = '<math xmlns="http://www.w3.org/1998/Math/MathML">';
            newreq = newreq + res1;
            req.id = counter;
            req.newreq = newreq;
    
          }
    
          // console.log(req);
    
          newarray.push(req);
    
    
          counter++;
        }, Promise.resolve());
    
    
    
        if (newarray.length == 0) {
    
          let req = {
            id: 1,
            newreq: item
          }
    
          newarray.push(req);
        }
    
        // console.log(item);
    
        const config = {
          CommonHTML: { linebreaks: { automatic: true } },
          showMathMenu: false,
          'HTML-CSS': {
            linebreaks: { automatic: true, width: 'container' },
            scale: 100
          }
        };
        
        return (
    
          <>
            <TouchableOpacity style={{ textAlign: "left" }}
            >
    
              <MathJax
                math={item}
                config={config}
    
              />
    
    
            </TouchableOpacity>
    
    
          </>
    
    
        )
    
    
    
      }
    
    
      render() {
        const { pageActive, data, itemQuestion, dataQuiz } = this.state;
        const { isShowReview } = this.props;
        // Check if question is empty
        if (!itemQuestion) {
          return null;
        }
        const userAnswer = data.results.answered[itemQuestion.id];
        //const question = data.questions.find(x => x.id === itemQuestion.id);
        return (
          <>
          <Modal
            isVisible={isShowReview}
            style={{
              margin: 0,
             
              zIndex: 10000,
              width: "380px",
              height: '460px',
              backgroundColor: '#fff',
            }}>
            <View>
              {/* {this.state.visible && <View>
                <Dialog.Container style={{ height: "50%", width: "100%" }} visible={true}>
                  <Dialog.Title>Explanation   <TouchableOpacity onPress={this.closedialog}><Image source={Images.iconClose} style={styles.iconBack} />
                  </TouchableOpacity></Dialog.Title>
                  <ScrollView>
                  {this.state.ismathquestion == 'Yes' &&
                    <>
                      <TouchableOpacity>{this.rennderMath('')}</TouchableOpacity>
                    </>
                  }
    
                  {this.state.ismathquestion == 'No' &&
                    <>
                      <TouchableOpacity>
                        <RenderDataHTML
                          html={this.state.explainationcontent}
                          style={styles.txtItemQuestion}
                        />
                      </TouchableOpacity>
                    </>
                  }
    
    
          </ScrollView>
                </Dialog.Container>
              </View>} */}
               
              <TouchableOpacity
                hitSlop={{ top: 10, left: 10, right: 10, bottom: 10 }}
                style={{ marginTop: 40, marginLeft: 10 }}
                onPress={() => this.props.onClose()}>
                <IconI name="close" color="#000" size={28} />
              </TouchableOpacity>
            </View>
            {this.state.topics && <ReviewSubjectTypes resdata={this.state.topics}/> }
            <View style={{ flex: 1, backgroundColor: '#fff' }}>
              <ScrollView style={{paddingHorizontal:16,height:200,width:"345px"}}>
               
                {data.questions.length > 1 && (
                  <>
                    <View style={styles.viewPage}>
                      <TouchableOpacity
                        style={styles.btnPage}
                        onPress={this.onPrevQuiz}
                        disabled={pageActive === 0}>
                        <IconI name="chevron-back-outline" />
                      </TouchableOpacity>
    
                      <FlatList
                        ref={ref => {
                          this.flatListRef = ref;
                        }}
                        data={dataQuiz.questions}
                        horizontal
                        style={styles.flatPage}
                        contentContainerStyle={styles.flatPageContainer}
                        showsHorizontalScrollIndicator={false}
                        keyExtractor={(item, index) => String(index)}
                        renderItem={({ item, index }) =>
                          this.renderHeaderItem({ item, index })
                        }
                        getItemLayout={(data, index) => ({
                          length: 30, // Specify the height of your list item
                          offset:(30*index)+index,
                          index
                        })}
                      />
                      <TouchableOpacity
                        style={styles.btnPage}
                        disabled={dataQuiz.questions.length === pageActive + 1}
                        onPress={this.onNextQuiz}>
                        <IconI name="chevron-forward-outline" />
                      </TouchableOpacity>
                    </View>
                  </>
                )}
                {itemQuestion && (
                  <View style={styles.viewQuestion}>
                    {itemQuestion?.ismathquestion == 'Yes' && <>
    
                      {this.rennderMath(itemQuestion?.title)}
                    </>}
    
    
    
    
    
                    {itemQuestion?.ismathquestion == 'No' && <RenderDataHTML
                      html={itemQuestion?.title}
                      style={styles.txtTitleQuestion}
                    />}
    
                    <RenderDataHTML html={itemQuestion?.content} />
    
                    {(itemQuestion.type === 'true_or_false' ||
                      itemQuestion.type === 'single_choice') &&
                      itemQuestion.options.map((item, i) =>
                        this.itemOption(item, i),
                      )}
    
                    {itemQuestion.type === 'multi_choice' &&
                      itemQuestion.options.map((item, i) =>
                        this.itemOptionMultiChoice(item, i),
                      )}
                    {itemQuestion.type === 'fill_in_blanks' && (
                      <View style={{ flexDirection: 'row', flexWrap: 'wrap' }}>
                        {itemQuestion.options.map((item, i) =>
                          this.renderFillInBlanks(item, i),
                        )}
                      </View>
                    )}
    
                    {itemQuestion.type === 'sorting_choice' &&
                      this.renderItemSortChoice(itemQuestion)}
                  </View>
                )}
                <View
                  style={{
                    flexDirection: 'row',
                    alignItems: 'center',
                    marginTop: 30,
                    marginBottom:20
                  }}>
                  {userAnswer?.correct ? (
                    <View
                      style={{
                        paddingHorizontal: 8,
                        paddingVertical: 6,
                        backgroundColor: '#58C3FF',
                        alignSelf: 'flex-start',
                        borderRadius: 4,
                      }}>
                      <Text style={{ color: '#fff' }}>
                        Correct
                      </Text>
                    </View>
                  ) : (
                    <View
                      style={{
                        paddingHorizontal: 8,
                        paddingVertical: 6,
                        backgroundColor: '#F46647',
                        alignSelf: 'flex-start',
                        borderRadius: 4,
                      }}>
                      <Text style={{ color: '#fff' }}>
                        Incorrect
                      </Text>
                    </View>
                  )}
                  <Text style={{ marginLeft: 16 }}>
                    {/* {t('learningScreen.quiz.point', {
                      point: `${userAnswer?.mark} / ${question.point}`,
                      interpolation: {escapeValue: false},
                    })}*/}
                  </Text>
                  {userAnswer?.explanation ? (
                    <TouchableOpacity
                      style={{
                        flexDirection: 'row',
                        alignItems: 'center',
                        marginLeft: 16,
                        alignSelf: 'flex-start',
                        borderBottomWidth: 2,
                        borderBottomColor: '#b334af',
                      }}
                      /* onPress={() =>
                         Alert.alert(
                           'Explanation',
                           userAnswer.explanation,
                         )
                       }*/
    
                      onPress={() => this.showdialogbox(userAnswer.explanation, itemQuestion.ismathquestion)}
                    /* onPress={() => {
                      this.setState({ isViewContent: true });
                    }}*/
                    >
                      <IconF name="navigation" color="#b334af" size={14} />
                      <Text
                        style={{
                          color: '#b334af',
                          marginLeft: 5,
                          fontFamily: 'Poppins-Medium',
                        }}>
                        Explanation
                      </Text>
                    </TouchableOpacity>
                  ) : null}
                </View>
                 {/* {this.state.visible && <View style={{ paddingVertical: '10px',marginBottom:"50px" }}>
              <Text style={{ fontSize: "24px", color: '#36CE61' }}>Explanation:   </Text>

              {this.state.ismathquestion == 'Yes' &&
                <>
                  <TouchableOpacity style={{ fontSize: "24px", marginBottom:"20px",width:"340px  !important" }}>{this.rennderMath(this.state.explainationcontent)}</TouchableOpacity>
                </>
              }

              {this.state.ismathquestion == 'No' &&
                <>
                  <TouchableOpacity>
                    <RenderDataHTML

                      html={this.state.explainationcontent}
                      style={styles.txtItemQuestion}
                    />
                  </TouchableOpacity>
                </>
              }




            </View>} */}
              </ScrollView>
    
            
            </View>
    
          </Modal>
          <Modal isVisible={this.state.showExplaination} style={{backgroundColor:"white",padding:"10px", display:"flex", flexDirection:"column" , alignItems:'flex-start',height:"100%"}}>
             <ScrollView style={{overflow:'scroll', width:'300px'}}>
             <TouchableOpacity style={{width:"60px", height:"30px", textAlign:"center", backgroundColor:"red", color:"white", paddingTop:'6px',marginBottom:"10px", fontWeight:"bold", borderRadius:"4px",}} onPress={()=>this.setState({showExplaination:false})}>Close</TouchableOpacity>
              <Text style={{ fontSize: "20px", color: '#36CE61' }}>Explanation:</Text>

              {this.state.ismathquestion == 'Yes' &&
                <>
                  <TouchableOpacity style={{ fontSize: "16px", marginBottom:"20px" }}>{this.rennderMath(this.state.explainationcontent)}</TouchableOpacity>
                </>
              }

              {this.state.ismathquestion == 'No' &&
                <>
                  <TouchableOpacity>
                    <RenderDataHTML

                      html={this.state.explainationcontent}
                      style={styles.txtItemQuestion}
                    />
                  </TouchableOpacity>
                </>
              }
             </ScrollView>

            </Modal>
          </>
    
    
    
    
    
    
        );
      }
}
export default withTranslation()(ReviewTest);
